import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import styled from 'styled-components'

import filterColumnTypes from 'constants/filterColumnTypes'

import Select from 'components/Shared/Select/Index'
import OperatorBadge from './OperatorBadge'

const StyledSelect = styled(Select)`
  min-width: 140px;
`

const PORTAL_Z_INDEX = 10001

const defaultTextFieldOptionsMap = {
  'like': 'like',
  'not_like': 'not like',
  'equal': 'equal',
  'not_equal': 'not equal',
  'empty': 'empty',
  'not_empty': 'not empty',
}

const bondedFieldOptionsMap = {
  'equal': 'equal',
}

const selectFieldOptionsMap = {
  'in': 'in',
  'not_in': 'not in',
  'like': 'like',
  'not_like': 'not like',
  'empty': 'empty',
  'not_empty': 'not empty',
}

const statusFieldOptionsMap = {
  'in': 'in',
  'not_in': 'not in',
  'like': 'like',
  'not_like': 'not like',
}

const datetimeFieldOptionsMap = {
  'is': 'is',
  'empty': 'empty',
  'not_empty': 'not empty',
  '>': '>',
  '>=': '>=',
  '<': '<',
  '<=': '<=',
}

const createdByFieldOptionsMap = {
  'equal': 'equal',
  'not_equal': 'not equal',
  'empty': 'empty',
  'not_empty': 'not empty',
}

const optionsByType = {
  [filterColumnTypes.DATETIME]: datetimeFieldOptionsMap,
  [filterColumnTypes.DATE]: datetimeFieldOptionsMap,
  [filterColumnTypes.STATUS]: statusFieldOptionsMap,
  [filterColumnTypes.SELECT]: selectFieldOptionsMap,
  [filterColumnTypes.BONDED]: bondedFieldOptionsMap,
  [filterColumnTypes.CREATEDBY]: createdByFieldOptionsMap,
}

export const getOptions = (filterField) => {
  const options = []
  const iconComponentsMap = {}

  if (!filterField) {
    return ({ options, iconComponentsMap })
  }

  const optionsMap = optionsByType[filterField.fieldType] || defaultTextFieldOptionsMap

  Object.keys(optionsMap).forEach((value) => {
    options.push({
      value: value,
      label: '',
    })
    iconComponentsMap[value] = <OperatorBadge name={optionsMap[value]} />
  })
  return ({ options, iconComponentsMap })
}

const OperatorSelectComponent = ({ value, onChange, filterField, isGlobal }) => {
  const { t } = useTranslation()

  const { options, iconComponentsMap } = getOptions(filterField)
  const isValueExist = options.some(o => o.value === value)

  // select 1st option if current value is absent in options
  useEffect(() => {
    if (options.length && (!value || !isValueExist)) {
      onChange(options[0].value)
    }
  })

  return (
    <StyledSelect
      small
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t('ticketProviderTicketsPage.filterForm.selectOperatorPlaceholder')}
      usePortal
      portalZindex={PORTAL_Z_INDEX}
      iconComponentsMap={iconComponentsMap}
      dataTest='operator'
    />
  )
}

OperatorSelectComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filterField: PropTypes.object,
  isGlobal: PropTypes.bool,
}

const OperatorSelectField = ({ name, filterField, isGlobal }) => {
  return (
    <Field
      name={name}
    >
      {({ input, meta }) => {
        return (
          <OperatorSelectComponent
            value={input.value}
            onChange={input.onChange}
            filterField={filterField}
            isGlobal={isGlobal}
          />
        )
      }}
    </Field>
  )
}

OperatorSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  filterField: PropTypes.object,
  isGlobal: PropTypes.bool.isRequired,
}

export default OperatorSelectField
